import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from './supabase';

const AuthContext = createContext(null);

// Menja korisnika samo ako je zaista drugi korisnik (drugi id).
// Supabase ponovo javlja isti login kad se vratiš na tab — to ignorišemo,
// inače se cela aplikacija ponovo učitava i nesačuvane forme se brišu.
function keepIfSameUser(prev, next) {
  return (prev?.id || null) === (next?.id || null) ? prev : next;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser((prev) => keepIfSameUser(prev, session?.user || null));
      setLoading(false);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser((prev) => keepIfSameUser(prev, session?.user || null));
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  const signOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <AuthContext.Provider value={{ user, loading, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
